export default __webpack_public_path__ + "static/media/Tormenta.5b1798cb.jpg";